'use client'

import { IconTrashX } from '@tabler/icons-react'
import Image from 'next/image'
import { pathOr } from 'ramda'

import {
  getPricePerUnit,
  getProductUnitDetails,
  ProductTypes
} from 'modules/products'
import IconButton from 'shared/ui/IconButton'

import styles from './SubstituteProductCard.module.scss'

export type SubstituteProductCardProps = {
  replacement: ProductTypes
  itemId: string
  idxOnList: number
  onRemoveProduct: (v: {
    replacement: ProductTypes
    idxOnList: number
    itemId: string
  }) => void
}

const SubstituteProductCard = ({
  onRemoveProduct,
  ...restProps
}: SubstituteProductCardProps): React.ReactNode => {
  const { replacement } = restProps
  const { producer, name } = replacement

  const unitDetails = getProductUnitDetails(replacement)
  const pricePerUnit = getPricePerUnit(replacement)

  const productImage = pathOr(
    '/static/photo-placeholder.svg',
    ['files', 0, 'thumbnailPathMedium'],
    replacement
  )

  const handleRemoveProduct = () => {
    onRemoveProduct(restProps)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageWrapper}>
        <Image
          className={styles.image}
          src={productImage}
          alt={name}
          width={144}
          height={144}
        />
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.madeBy}>{producer?.name || '———'}</div>
        <h3 className={styles.name}>{name}</h3>
        <div className={styles.grammarWrapper}>
          {unitDetails && <div className={styles.grammar}>{unitDetails} - </div>}
          <div
            className={styles.pricePerGrammar}
            dangerouslySetInnerHTML={{ __html: pricePerUnit }}
          />
        </div>
      </div>
      <div className={styles.productAvailabilityParagraph}>
        Produkt niedostępny
      </div>
      <div className={styles.iconSectionWrapper}>
        <IconButton
          onClick={handleRemoveProduct}
          size='small'
          variant='transparent'
          aria-label={`Usuń produkt ${name}`}
        >
          <IconTrashX className={styles.trashIcon} />
        </IconButton>
      </div>
    </div>
  )
}

export default SubstituteProductCard
